module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAApklEQVQ4jd2UQQrCMBBFn7boCewtepvSY3TTpesuhK4ED9H2Op6i4LIbqSADUxExkpjZ6Nsk8JnHJBOyyusLnjRABRyB/UvJIwsRzkACXIGtK1v72rRA2HzKQoRe/KZwB3RWwgI4A2WscOlqALJvZUKqXZ1iRc8dmk5aZD2Q63FNhMKogyh1Hy1cGGK7fXd/o8WzMeO/hDdd5YN1ZiHCAzABrTOD9g528x5W1YKi9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close-icon.png
// module id = j64r
// module chunks = 1